export function getCustomerOnboardingStatus(customer = {}) {
  const contacts = Array.isArray(customer?.contacts) ? customer.contacts : [];
  const hasActiveContact = contacts.some((contact) => contact?.active);

  if (customer?.metadata?.onboarded || customer?.active) {
    return {
      id: "fully-onboarded",
      label: "Fully onboarded",
      color: "green",
      description: "Owner account and company setup are complete.",
    };
  }

  if (hasActiveContact) {
    return {
      id: "account-activated",
      label: "Account activated",
      color: "blue",
      description: "The owner account is active, but company setup is still pending.",
    };
  }

  if (contacts.length > 0) {
    return {
      id: "invite-sent",
      label: "Invite sent",
      color: "yellow",
      description: "The owner invite has been sent and setup has not been completed yet.",
    };
  }

  return {
    id: "draft",
    label: "Draft",
    color: "gray",
    description: "The customer record exists, but no onboarding owner is attached yet.",
  };
}
